import buildSimpleStringFilter from '../buildSimpleStringFilter'

const ConditionFilter = buildSimpleStringFilter({
  key: 'condition',
  expandedOnInit: true,
})

export default ConditionFilter
